export const SummerData = [
    {
        id:1,
        image:"/images/AboutUs/Summer Camp/Drawing.webp",
        title:"Drawing"
    },
    {
        id:2,
        image:"/images/AboutUs/Summer Camp/Computer.webp",
        title:"Computer Training"
    },
    {
        id:3,
        image:"/images/AboutUs/Summer Camp/English.webp",
        title:"Communicative English"
    },
    {
        id:4,
        image:"/images/AboutUs/Summer Camp/Sports.webp",
        title:"Sports"
    },
    {
        id:5,
        image:"/images/AboutUs/Summer Camp/Abacus.webp",
        title:"Abacus"
    },
    {
        id:6,
        image:"/images/AboutUs/Summer Camp/Handwriting.webp",
        title:"Handwriting"
    },
    {
        id:7,
        image:"/images/AboutUs/Summer Camp/Tailoring.webp",
        title:"Tailoring"
    },
];
